/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { PayRunStatus } from "./PayRunStatus";
import {
  PayRunStatusFromJSON,
  PayRunStatusFromJSONTyped,
  PayRunStatusToJSON,
  PayRunStatusToJSONTyped,
} from "./PayRunStatus";
import type { PayRunLineDto } from "./PayRunLineDto";
import {
  PayRunLineDtoFromJSON,
  PayRunLineDtoFromJSONTyped,
  PayRunLineDtoToJSON,
  PayRunLineDtoToJSONTyped,
} from "./PayRunLineDto";

/**
 *
 * @export
 * @interface PayRunDetail
 */
export interface PayRunDetail {
  /**
   *
   * @type {string}
   * @memberof PayRunDetail
   */
  payRunId: string;
  /**
   *
   * @type {LocalDate}
   * @memberof PayRunDetail
   */
  periodStart: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof PayRunDetail
   */
  periodEnd: LocalDate;
  /**
   *
   * @type {PayRunStatus}
   * @memberof PayRunDetail
   */
  status: PayRunStatus;
  /**
   *
   * @type {string}
   * @memberof PayRunDetail
   */
  createdByEmail: string;
  /**
   *
   * @type {Array<PayRunLineDto>}
   * @memberof PayRunDetail
   */
  lines: Array<PayRunLineDto>;
}

/**
 * Check if a given object implements the PayRunDetail interface.
 */
export function instanceOfPayRunDetail(value: object): value is PayRunDetail {
  if (!("payRunId" in value) || value["payRunId"] === undefined) return false;
  if (!("periodStart" in value) || value["periodStart"] === undefined)
    return false;
  if (!("periodEnd" in value) || value["periodEnd"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("createdByEmail" in value) || value["createdByEmail"] === undefined)
    return false;
  if (!("lines" in value) || value["lines"] === undefined) return false;
  return true;
}

export function PayRunDetailFromJSON(json: any): PayRunDetail {
  return PayRunDetailFromJSONTyped(json, false);
}

export function PayRunDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PayRunDetail {
  if (json == null) {
    return json;
  }
  return {
    payRunId: json["payRunId"],
    periodStart: json["periodStart"],
    periodEnd: json["periodEnd"],
    status: PayRunStatusFromJSON(json["status"]),
    createdByEmail: json["createdByEmail"],
    lines: (json["lines"] as Array<any>).map(PayRunLineDtoFromJSON),
  };
}

export function PayRunDetailToJSON(json: any): PayRunDetail {
  return PayRunDetailToJSONTyped(json, false);
}

export function PayRunDetailToJSONTyped(
  value?: PayRunDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    payRunId: value["payRunId"],
    periodStart: value["periodStart"],
    periodEnd: value["periodEnd"],
    status: PayRunStatusToJSON(value["status"]),
    createdByEmail: value["createdByEmail"],
    lines: (value["lines"] as Array<any>).map(PayRunLineDtoToJSON),
  };
}
